import { useEffect, useState } from "react";
import { supabase } from "./supabase";

export default function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div style={{ background: "#F5F0E8", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ width: 48, height: 48, background: "#1B3A6B", borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2C8 6 6 10 8 14c-2-1-3-3-3-5C3 13 2 17 5 20c1.5 1.5 3.5 2 6 2 5 0 8-3 8-7 0-2-1-4-2.5-5.5C16 11 15 13 13 14c1-3 0-7-1-12z"/>
          </svg>
        </div>
      </div>
    );
  }

  if (!user) {
    window.location.href = "/login";
    return null;
  }

  return children;
}